import styled from "styled-components";

export const LoaderBox = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
`;
